import React, { useState } from "react";
import Style from "./ProductSliderItem.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as fillHeart } from "@fortawesome/free-solid-svg-icons";
import { calcDiscountPercent, randomNumberInRange } from "../../Utils/Helper/Helper";
import { separate } from "../../Seprate/Seprate";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { useHistory } from "react-router-dom";
const ProductSliderItem = ({ item ,addFavorite}) => {
    const history=useHistory()
  return (
    <div className={`${Style.SlideItemHolder} keen-slider__slide`}>
      <div className={Style.favoriteHolder} onClick={()=>addFavorite(item)}>
        {parseInt(item.favorite) === 0 ? (
          <FontAwesomeIcon icon={faHeart} />
        ) : (
          <FontAwesomeIcon icon={fillHeart} color="red" />
        )}
      </div>
      <div
        className={Style.shopLogoHolder}
        onClick={() => history.push(`/supplier/${item.supplier_id}/`)}
      >
        {/* logo skeleton until loaded */}
        {/** local state controls show/hide of actual img */}
        <img
          src={`//cdn.barest.ir/supplier/logo/${item?.logo}.jpg`}
          alt={item?.supplier}
          className={Style.hiddenUntilLoaded}
          onLoad={(e) => (e.currentTarget.dataset.loaded = "true")}
          onError={(e) => (e.currentTarget.dataset.loaded = "true")}
        />
        <div className={Style.skeleton + " " + Style.logoSkeleton} aria-hidden="true"></div>
      </div>

      <div
        className={Style.ImageHolder}
        onClick={() => history.push(`/product/${item.id}/${item.supplier_id}`)}
      >
        <img
          src={`//cdn.barest.ir/product/m/${item.id}.jpg`}
          alt={item?.name}
          className={Style.hiddenUntilLoaded}
          onLoad={(e) => (e.currentTarget.dataset.loaded = "true")}
          onError={(e) => (e.currentTarget.dataset.loaded = "true")}
        />
        <div className={Style.skeleton + " " + Style.imageSkeleton} aria-hidden="true"></div>
      </div>
      <div className={Style.ProductInfo}>
        <h5 onClick={()=>history.push(`/product/${item.id}/${item.supplier_id}`)}>{item.name}</h5>
        {parseInt(item.off_price) !== 0 && (
          <div className={Style.offPriceHolder}>
            <p>{calcDiscountPercent(item.price, item.off_price)}%</p>
            <span>{item.price}</span>
          </div>
        )}
        <p className={Style.ProductPrice}>
          {separate(
            parseInt(item.off_price) !== 0 ? item.off_price : item.price
          )}
          <span> تومان</span>
        </p>
      </div>
    </div>
  );
};

export default ProductSliderItem;
